module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/campo-telefone/campo-telefone.component.scss
// module id = ./src/app/shared/componentes/campo-telefone/campo-telefone.component.scss
// module chunks = main